module.exports = __webpack_public_path__ + "static/img/wddd.4f1b1f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wddd.jpg
// module id = /zBE
// module chunks = 4